<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable || isSectionDeletable" [data]="loginData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true" [actionButtons]="actionButtons">
</ppl-list-table>

<div class="filter-panel">
  <ng-template #confirmationDialog let-cancel="cancel">
      <p>Are you sure you want to proceed ?</p>
  </ng-template>
</div>
